<div class="preloader-container flexi-center flex-1">
    <div class="loader-content">
      
            <ng-lottie class="bb-loader" [width]="40+size+'px'"
                       [height]="40+size+'px'"
                       [options]="options"></ng-lottie>
         
    </div>
</div>
